import { api } from '../..';
import { mapApiToEntity } from './mapper';
import { PropertyType } from '../../../common';

export const getDateTimes = (): Promise<PropertyType> =>
	api.get('/datetime').then((res) => {
		return mapApiToEntity(res.data);
	});
